import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/common/SEO';
import Breadcrumbs from '../../components/common/Breadcrumbs';

const PrivacyPolicy = () => {
    const pStyle = "mb-4 leading-relaxed text-sm sm:text-base";
    const h2Style = "text-lg sm:text-xl font-bold text-gray-800 border-b-2 border-blue-200 pb-2 mb-4";
    const ulStyle = "list-disc list-inside space-y-2 pl-4 mb-4 text-sm sm:text-base";

    return (
        <>
            <SEO 
                title="プライバシーポリシー（個人情報保護方針）| Billwave"
                description="株式会社シグナルが運営する「Billwave」のプライバシーポリシー（個人情報保護方針）です。お客様の個人情報の取得目的、管理体制、第三者提供、安全管理措置に関する取り扱い方針を明記しています。"
                path="/privacy-policy"
            />
            <div className="max-w-4xl mx-auto px-4 py-8">
                <Breadcrumbs items={[{ label: '個人情報保護方針' }]} />

                <div className="bg-white p-8 rounded-lg shadow border border-gray-100 text-gray-700">
                    <h1 className="text-3xl font-extrabold text-gray-900 text-center mb-10">個人情報保護方針</h1>
                    
                    <div className="space-y-8">
                        <div>
                            <h2 className={h2Style}>１．当社では、お客様の個人情報を以下の目的以外には利用いたしません。</h2>
                            <ul className={ulStyle}>
                                <li>①弊社サービスのご案内などを提供するため、郵便、電話、電子メールなどの方法によりお知らせすること</li>
                                <li>②当社において取り扱う商品・サービスなどあるいは各種イベント・キャンペーンなどの開催について、郵便、電話、電子メールなどの方法によりご案内すること</li>
                                <li>③商品開発あるいは顧客満足度向上策検討のため、アンケート調査を実施すること</li>
                                <li>④与信判断及び与信管理</li>
                                <li>⑤以下の個人情報を書面または電子媒体により、当社の提携会社に提供すること。但し、本人の申し出により第三者提供を停止いたします。提供する項目：企業名・部署名・住所・氏名・電話番号・メールアドレス、及びお客様とのお取引に関する情報</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className={h2Style}>２．当社は、お客様の個人情報を、上記1-⑤.にて定めた提供先を除き、正当な理由のない限り他社、第三者に提供いたしません。</h2>
                            <p className={pStyle}>但し、お客様もしくはお客様の保証人が下記の事項に該当した場合、お客様の個人情報を当社の提携会社間で与信判断及び契約後のお取引の参考資料として利用するため、共同して利用することがあります。</p>
                            <ul className={ulStyle}>
                                <li>①当社に振出した手形・小切手を不渡りにし、又支払停止となった場合</li>
                                <li>②当社に支払の一部または全額の支払い猶予を要請し、当社がそれに応じた場合</li>
                                <li>③当社との個別取引において、お客様の都合により当社への支払いが遅滞した場合</li>
                                <li>④破産・民事再生・会社整理・特別清算などの申立をしたとき、または監督官庁より営業許可の取消しを受けた場合</li>
                            </ul>
                            <p className={pStyle}>共同利用する情報は、住所・氏名・生年月日・電話番号・勤務先及び当該契約の契約日・商品名・契約額・支払回数・契約残高・月々の支払い状況などに限定します。 お客様の個人情報についての共同利用に関する管理責任者は、当社とします。</p>
                        </div>

                        <div>
                            <h2 className={h2Style}>３．当社は、お客様がご本人様の個人情報の確認、訂正などを希望される場合は、当社の定める書面の提出により開示に応じます。</h2>
                            <p className={pStyle}>開示請求書など当社の定める書面の入手方法につきましては、当社の個人情報のお問い合わせ窓口までお問い合わせください。開示請求を希望される場合はご本人であることが確認できるもの（運転免許証など）をご用意ください。</p>
                        </div>

                        <div>
                            <h2 className={h2Style}>４．個人情報の取り扱いに関する問い合わせ窓口</h2>
                            <ul className={ulStyle}>
                                <li>TEL：03-6426-5805</li>
                                <li>コンタクトフォーム</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className={h2Style}>５．当社は、お客様の個人情報の取り扱いに関係する日本の法令、その他の規範を遵守します。</h2>
                        </div>

                        <div>
                            <h2 className={h2Style}>６．当社は、お客様の個人情報について、適切な安全措置を講ずることにより、漏えい、改ざん、紛失などの危険防止に努めます。</h2>
                        </div>
                        
                        <div>
                            <h2 className={h2Style}>７．当社は、個人情報の取り扱いに関して、定期的に監査を行い、常に継続的改善に努めます。</h2>
                        </div>

                        <div>
                            <h2 className={h2Style}>８．Cookieの利用について</h2>
                            <p className={pStyle}>
                                当社は、サービスの提供および利用状況の分析、アクセスの利便性向上のためにCookie（クッキー）および類似の技術を利用しています。Cookieに関する詳細な取り扱い、分類、保存期間および設定変更方法については、当社の{' '}
                                <Link to="/cookie-policy" className="text-blue-600 underline font-semibold hover:text-blue-800">
                                    Cookieポリシー
                                </Link>{' '}
                                をご確認ください。
                            </p>
                        </div>

                        <div className="text-right mt-10 pt-6 border-t border-gray-200">
                            <p>平成24年10月1日制定</p>
                            <p className="mt-1">平成28年8月6日改定</p>
                            <p className="font-bold mt-1">株式会社シグナル</p>
                            <p>代表取締役社長　長澤五郎</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PrivacyPolicy;
